<template>
  <div
    class="layout"
    :class="{'opacity' : showModal.isForgotAccount}"
  >
    <Transition name="fade">
      <img
        v-if="qualificationFunction('showContecLogo')"
        class="logo"
        :class="{ 'logined_logo' : accessedMemberInfo.name }"
        src="@/assets/images/ContecLogo.png"
        alt="Contec Logo"
      />
    </Transition>
    <Transition name="fade">
      <div v-if="qualificationFunction('showMobileLayout')" class="layout_inner_wrap">
        <Transition name="fade">
          <img
            v-if="qualificationFunction('showMainLogo')"
            class="logined_main_logo"
            src="@/assets/images/MobileLogo.png"
            alt="Mobile mainLogo"
          >
        </Transition>
        <div class="layout_inner">
          <img
            v-if="qualificationFunction('showMobileContents')"
            class="main_logo"
            src="@/assets/images/SideLogo.png"
            alt="Mobile mainLogo"
          >
          <TransitionGroup
            v-if="qualificationFunction('showMobileContents')" tag="div"
            name="fade"
            class="contents"
          >
            <template
              v-if="qualificationFunction('showLoginBox')"
            >
              <LoginBox />
            </template>
            <SatelliteInfo v-if="qualificationFunction('showContentsSatelliteInfo')" />
          </TransitionGroup>
          <Transition v-else name="fade">
            <SatelliteInfo
              v-if="qualificationFunction('showSatelliteInfo')"
            />
          </Transition>
        </div>
        <Transition name="fade">
          <div
            v-if="qualificationFunction('showBottomText')"
            class="bottom_text_center"
          >
            <p class="bottom_text_bold">
              COPY RIGHT
            </p>
            <p class="bottom_text_regular">
              CONTEC Co., Ltd. all right reserved
            </p>
          </div>
        </Transition>
        <IconButtons />
      </div>
    </Transition>
    <Transition name="fade">
      <button
        v-if="isImageMode" type="button"
        class="image_mode_btn"
        @click="imageModeToggle"
      >
        <span>
          <ImageModeSvg />
        </span>
        IMAGE MODE
      </button>
    </Transition>
    <Transition name="fade">
      <button
        v-if="qualificationFunction('showMobileLicenseBtn')"
        class="license_btn"
        type="button"
        :disabled="qualificationFunction('disabledMobileLicenseBtn')"
        @click="LicenseModalToggle"
      >
        <img src="@/assets/images/PolicyIcon.png" alt="PolicyIcon">
      </button>
    </Transition>
    <LoginedPanel />
    <Transition name="fade">
      <div v-if="isLoading" class="orbit_spinner_wrap">
        <OrbitSpinner
          :animationDuration="1200"
          fill="$color-white"
        />
      </div>
    </Transition>
    <SuccessModal v-if="qualificationFunction('biggerHeight')" />
    <FailedModal v-if="qualificationFunction('biggerHeight')" />
    <ForgotAccountModal v-if="qualificationFunction('biggerHeight')" />
    <LicenseModal />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { OrbitSpinner } from 'epic-spinners';

import LoginBox from '@/components/common/LoginBox.vue';
import FailedModal from '@/components/common/modal/FailedModal.vue';
import ForgotAccountModal from '@/components/common/modal/ForgotAccountModal.vue';
import LicenseModal from '@/components/common/modal/LicenseModal.vue';
import SuccessModal from '@/components/common/modal/SuccessModal.vue';
import SatelliteInfo from '@/components/common/SatelliteInfo.vue';
import IconButtons from '@/components/mobile/IconButtons.vue';
import LoginedPanel from '@/components/mobile/LoginedPanel.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


const { isLoading, isImageMode } = storeToRefs(useCommonStore());
const { imageModeToggle, LicenseModalToggle, windowSize, showPanel, showModal } = useCommonStore();
const { accessedMemberInfo } = useMemberStore();

const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showMainLogo':
      return !!((accessedMemberInfo.name || windowSize.width > windowSize.height) && (!showPanel.isMobileAccountInfo || windowSize.width > windowSize.height));
    case 'showContecLogo':
      return !isImageMode.value && windowSize.width > windowSize.height || showModal.isLicense || showPanel.isMobileAccountInfo;
    case 'showSideLogo':
      return !accessedMemberInfo.name && windowSize.width < windowSize.height;
    case 'showMobileLayout':
      return !isImageMode.value && !showModal.isLicense;
    case 'showMobileContents':
      return !accessedMemberInfo.name && windowSize.width < windowSize.height;
    case 'showLoginBox':
      return showPanel.isLogin && !showModal.isForgotAccount && !showModal.isFail && !showModal.isSuccess;
    case 'showContentsSatelliteInfo':
      return !showPanel.isLogin && !showModal.isFail;
    case 'showSatelliteInfo':
      return !showPanel.isMobileAccountInfo || (showPanel.isMobileAccountInfo && windowSize.width > windowSize.height);
    case 'showBottomText':
      return windowSize.height > 720 && windowSize.width < windowSize.height;
    case 'showImageModeBtn':
      return isImageMode.value && (windowSize.width > 1280 && windowSize.height > 720);
    case 'showMobileLicenseBtn':
      return !isImageMode.value && (!showPanel.isMobileAccountInfo || windowSize.width > windowSize.height);
    case 'disabledMobileLicenseBtn':
      return windowSize.width < windowSize.height && (showModal.isFail || showModal.isForgotAccount);
    case 'biggerHeight':
      return windowSize.width < windowSize.height;
    default:
      return false;
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.layout {
  display: flex;
  width: 100vw;
  height: 100dvh;
  position: relative;
  z-index: 200;
  overflow: hidden;
  pointer-events: none;

  .logo {
    width: 73px;
    transition: 0.5s;
    transition-delay: -0.1s;
    position: absolute;
    top: 30px;
    left: 22px;
    z-index: 200;

    &.logined_logo {
      left: 22px;
      transform: translateX(0);
    }
  }

  .info_box,
  .login_box {
    position: absolute;
  }

  .info_box {
    bottom: 0;

    &.user {
      left: calc(50% + 20px);
    }

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }

    .area_info_list {
      gap: 10px;
    }

    .satellite_info_box {
      .info_list {
        font-size: 10px;

        div {
          font-size: 12px;
        }
      }
    }
  }

  .login_box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .layout_inner_wrap {
    width: 393px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;

    .logo, .main_logo, .bottom_text_center, .icon_buttons {
      transition: 0.5s;
    }

    &.opacity {
      .logo, .main_logo, .bottom_text_center, .icon_buttons {
        opacity: 0.6;
      }
    }

    .logined_main_logo {
      width: 393px;
      position: absolute;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 200;
    }

    .layout_inner {
      width: 70%;
      min-height: 600px;
      max-height: 700px;
      height: calc(100dvh - 500px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 200;

      img {
        width: 100%;
      }

      .main_logo {
        width: 257.9px;
      }

      .contents {
        width: 100%;
        height: calc(100% - 134.44px);
        position: relative;

        .sign_up {
          font-size: 9.3px;
          color: $color-white;
          width: 100%;
          pointer-events: auto;

          > div {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 2%;
            transform: translateY(-50%);
          }

          .fade-enter-active {
            transition: all 0.3s ease-out;
            transition-delay: 0.3s;
          }

          .fade-leave-active {
            transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
          }

          button {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 10px;

            i {
              font-size: 17px;
            }

            &.sign_up_btn {
              margin-left: 5px;

              i {
                margin-left: 5px;
              }
            }

            &.sign_up_cancel_btn {
              i {
                margin-right: 5px;
              }
            }
          }
        }
      }
    }

    .bottom_text_center {
      color: $color-debra;
      text-align: center;
      position: absolute;
      left: 50%;
      bottom: 80px;
      transform: translateX(-50%);
      z-index: 1;
    }

    .bottom_text_bold {
      font-family: "Poppins ExtraBold 800", sans-serif;
      font-size: 13px;
      line-height: 1.54;
    }

    .bottom_text_regular {
      font-family: "Poppins Medium 500", sans-serif;
      font-size: 10px;
      line-height: 1.3;
    }
  }

  .image_mode_btn {
    fill: $color-debra;
    color: $color-debra;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 3.8px;
    font-size: 8px;
    position: absolute;
    left: 22px;
    bottom: 17.3px;
    z-index: 200;
    pointer-events: auto;
  }

  .license_btn {
    width: 35.6px;
    position: fixed;
    right: 25px;
    bottom: 25px;
    z-index: 201;
    pointer-events: auto;

    img {
      width: 100%;
    }
  }

  .icon_buttons {
    bottom: 0;
    padding-bottom: 20px;
    gap: 15px;
  }

  .orbit_spinner_wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;

    &.fade-enter-active,
    &.fade-leave-active {
      transition: opacity 0.3s ease;
    }
  }

  .forget_panel,
  .warning_panel {
    position: absolute;
    top: 10%;
  }
}

// mobile 세로 모드
@media screen and (min-width: 250px) and (max-width: 499px) and (min-height: 450px) {
  .layout {
    .layout_inner_wrap {
      width: 100%;
      min-height: 0;

      .logined_main_logo {
        width: 100%;
        position: static;
        padding: 50px 31px 0;
        transform: translateX(0);
      }

      .layout_inner {
        width: 100%;
      }

      .image_mode_btn {
        position: fixed;
        bottom: 20px;
      }
    }
  }
}

@media screen and (max-height: 750px) {
  .layout {
    .layout_inner_wrap {
      .layout_inner {
        min-height: 500px;
      }
    }

    .login_box {
      top: 50%;
    }

    .warning_panel, .forget_panel {
      top: 10%;
    }
  }
}

// mobile 세로 모드 Gallaxy Fold
@media screen and (min-width: 279px) and (max-height: 654px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .layout {
    .logo {
      &.logined_logo {
        display: none;
      }
    }

    .license_btn {
      right: 10px;
      bottom: 20px;
    }
  }
}

// mobile 가로 모드
@media screen and (min-width: 600px) and (max-height: 450px) {
  .layout {
    .layout_inner_wrap {
      .layout_inner {
        min-height: inherit;
        max-height: inherit;
        height: 100dvh;
      }
    }
  }
}

// mobile 가로 모드 Gallaxy Fold
@media screen and (min-width: 653px) and (max-height: 280px) {
  .layout {
    .layout_inner_wrap {
      min-height: 0;

      .layout_inner {
        top: 15%;
        transform: translate(-50%, 0);
      }
    }
  }
}
</style>